import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MethodsHelper } from '@app/helpers/methods.helper';

@Component({
    selector: 'app-input-search',
    templateUrl: './input-search.component.html',
    styleUrls: ['./input-search.component.css'],
    standalone: false
})
export class InputSearchComponent{

  @Input() value: string;
  @Input() name: string;
  @Input() maxLength: number;
  @Input() isNumber: boolean;
  @Input() classInputName: string = 'w-95 mt-10 mb-10';
  @Output() onChangeValue = new EventEmitter<string>();
  @Output() onTriggerSearch = new EventEmitter<string>();
  @Input() isAlphabetOnly: boolean;

  onKeyPress(event: KeyboardEvent): boolean {
  const charCode = event.which ? event.which : event.keyCode;

  // allow control keys (backspace, tab, arrows)
  if (charCode <= 31) return true;

  if (this.isNumber) {
    return (
      (charCode >= 48 && charCode <= 57) ||
      charCode === 46 ||
      charCode === 44 ||
      charCode === 45
    );
  }

  if (this.isAlphabetOnly) {
    return (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode === 32
    );
  }

  return true;
}

  onInputChange() {
    this.onChangeValue.emit(this.value);
  }
  
  onKeyup() {
    this.onTriggerSearch.emit(this.value);
  }

  numberOnly(event): boolean {
    if (this.isNumber) {
      const charCode = (event.which) ? event.which : event.keyCode;
      return (
        (charCode >= 48 && charCode <= 57) ||    // Digits
        charCode == 46 ||                        // Decimal point
        charCode == 44 ||                        // Comma
        charCode == 45                           // Negative sign
      );
    } 
    return true
  }

  haveValue() {
    return MethodsHelper.haveValue(this.value);
  }

  onClear() {
    this.value = undefined;
    this.onChangeValue.emit(this.value);
    this.onTriggerSearch.emit(this.value);
  }
}
